<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="cui-calendar"></i> Periodicidade
                <b-link :to="`/${actionUri}/new/`" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-plus"></i>
                  Entrada
                </b-link>
            </div>
            <b-card-body>
                <b-row>
                  <b-col md="6" class="my-1">
                    <b-form-group label-cols-sm="0" label="" class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="keywords" v-on:keyup.enter="search" placeholder="Digite..."></b-form-input>
                        <b-input-group-append>
                          <b-button @click="search" variant="primary">Buscar</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                 <b-row>
                    <b-col lg="12">
                      <c-table @onPageIndexChanged="onPageIndexChanged" :table-data="result" :actionUri="actionUri" :loading="loading" :fields="fields" @onCustomActionClick="onCustomActionClick" striped></c-table>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <b-modal
          id="modal-remove"
          ref="removeModal"
          title="Remover periodicidade"
          @hidden="resetRemoveModal"
          @ok="handleRemoveModalOk"
          ok-title="Remover"
          cancel-title="Cancelar"
          v-model="removeModalVisible">
          <div class="alert alert-danger" role="alert" v-show="removeModel.hasError">{{removeModel.errorMessage}}</div>
          <form ref="form" @submit.stop.prevent="handleRemoveSubmit">
            <div class="form-row">
              <div class="col-sm-12">
                Você tem certeza que deseja remover o período {{removeModel.name}}?
              </div>
            </div>
          </form>
        </b-modal>
    </div>
</template>
<script>
import cTable from '../../../components/base/Table.vue'
import domainService from '../../../services/Partner/payoutIntervalService'
import listPage from '../../../mixins/listPage';
export default {
  components: {cTable},
  mixins: [listPage],
  data() {
    return {
      actionUri: 'configuration/payoutInterval',
      fields: [
        {key: 'name', label: 'Nome', sortable: false},
        {key: 'days', label: 'Dias', sortable: false},
        {key: 'actions', label: ''}
      ],
      removeModel: {
        id: 0,
        name: ''
      }
    }
  },
  methods: {
    fetchData(page) {
      const self = this
      self.showLoading()
      domainService.findAll(this.keywords, page).then((response) =>{
          self.$data.result = response.status == 204 ? self.getEmptyResult() : response.data
          self.hideLoading()
      }, () =>{
          self.hideLoading()
      })
    },
    resetRemoveModal() {
      this.removeModel.id = 0
      this.removeModel.name = ''
    },
    handleRemoveSubmit() {
      const self = this
      domainService.remove(self.removeModel.id).then((response) => {
        self.fetchData(1)
        self.$nextTick(() => {
          self.$refs.removeModal.hide()
        })
      },
      (error) => {
        self.removeModel.hasError = true
        self.removeModel.errorMessage = 'Ocorreu um erro na remoção do período'
      })
    },
    onCustomActionClick(action, row) {
      switch(action)
      {
        case 'remove':
          this.removeModel.id = row.item.id
          this.removeModel.name = row.item.name
          this.showRemoveModal()
        break
      }
    }
  }
}
</script>
